import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

// import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { doListNotification, doSendBatchNotification } from "services/notification.service";

export const onGetNotificationList = createAsyncThunk("notifications/onGetNotificationList", async (type: string) => {
  try {
    const response: any = await doListNotification(type, 0);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const onSendBatchNotification = createAsyncThunk("notifications/onSendBatchNotification", async (notification: Record<string, unknown>) => {
  try {
    const response: any = await doSendBatchNotification(notification);

    toast.success('Notification sent successfully');
    return response.data;
  } catch (error) {
    toast.error('Notification sent failed');
    return error;
  }
});